import { ButtonActions } from '../../../app.constants';

export class DocumentPaButton {

	action!: ButtonActions;
	label!: string;
	styleClass!: string;
	disabled: boolean = false;

	constructor(action: ButtonActions, label: string, styleClass: string, disabled: boolean = false) {
		this.action = action;
		this.label = label;
		this.styleClass = styleClass;
		this.disabled = disabled;
	}
}